import { PatchAppointmentStatus } from "./PatchAppointmentStatus";
import {
  buildTriggerInputFromPreConsultationContext,
  triggerPreConsultationAutomation,
  type PreConsultationAutomationTriggerContext,
} from "@/services/crm/triggerClinicalAutomation";

interface PatchAppointmentStatusParams {
  appointmentId: string;
  status?:
    | "proposed"
    | "pending"
    | "booked"
    | "arrived"
    | "fulfilled"
    | "cancelled"
    | "noshow"
    | "entered-in-error"
    | "checked-in "
    | "waitlist";
}

interface PatchAppointmentStatusWithAutomationParams
  extends PatchAppointmentStatusParams {
  preConsultationTrigger?: PreConsultationAutomationTriggerContext | null;
}

/**
 * Wrapper de PatchAppointmentStatus que dispara automação de pré-consulta
 * quando o novo status for `booked` e o contexto opcional for informado.
 */
export async function patchAppointmentStatusAndTriggerPreConsultation(
  params: PatchAppointmentStatusWithAutomationParams,
) {
  const response = await PatchAppointmentStatus({
    appointmentId: params.appointmentId,
    status: params.status,
  });

  if (params.status === "booked" && params.preConsultationTrigger) {
    const triggerInput = buildTriggerInputFromPreConsultationContext(
      params.appointmentId,
      params.preConsultationTrigger,
    );
    if (triggerInput) {
      await triggerPreConsultationAutomation(triggerInput);
    }
  }

  return response;
}

export type { PreConsultationAutomationTriggerContext };
